var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SuggestionsApi } from '@ClientApi/suggestionsApi';
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const SET_SUGGESTIONS_LOADING = 'SET_SUGGESTIONS_LOADING';
export const REMOVE_SUGGESTION_ITEM = 'REMOVE_SUGGESTION_ITEM';
export class SetSuggestions {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_SUGGESTIONS;
    }
}
export class SetSuggestionsLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_SUGGESTIONS_LOADING;
    }
}
export class RemoveSuggestionItem {
    constructor(payload) {
        this.payload = payload;
        this.type = REMOVE_SUGGESTION_ITEM;
    }
}
export const fetchSuggestions = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetSuggestionsLoading(true));
    const suggestions = yield SuggestionsApi.getPosted();
    dispatch(new SetSuggestions(suggestions));
    dispatch(new SetSuggestionsLoading(false));
});
